<div class="container mx-auto px-4 py-6">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold">Detalle de la Mantención</h1>
      <button (click)="close()" class="bg-transparent text-red-600 border border-red-600 hover:bg-red-600 hover:text-white px-4 py-2 rounded-md">Cerrar</button>
    </div>
    <p><strong>ID:</strong> {{ maintenance?.id }}</p>
    <p><strong>Rol:</strong> {{ maintenance?.rol?.roleName }}</p>
    <p><strong>Tipo de Mantención:</strong> {{ maintenance?.maintenanceType?.name }}</p>
    <p><strong>Tipo de Envase:</strong> {{ maintenance?.containerType?.name }}</p>
    <p><strong>Estado:</strong> {{ maintenance?.disabled ? 'Deshabilitado' : 'Habilitado' }}</p>
  
    <!-- Botones de Cancelar y Editar -->
    <div class="flex justify-end mt-6 space-x-4">
      <button (click)="close()" class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Cancelar</button>
      <a [routerLink]="['/maintenances/update', maintenance?.id]" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">Editar</a>
    </div>
  </div>
  